import { Component, OnInit } from '@angular/core';
import { SubmissionService, SubmissionDefaults } from '../../services/submission.service';
const packet = require('./test-packet.json');
@Component({
    selector: 'app-mapping-test',
    template: `<br/><br/><hr/><pre style="margin-left: 50px">{{a}}</pre><hr/><br/><br/>`,
    standalone: true
})
export class MappingTestComponent implements OnInit {

  public a = '';
  constructor(public submissionService: SubmissionService) { }

  ngOnInit() {
    const testPacket1 = packet;
    const defaults: SubmissionDefaults = {
      purposeType: 'home-loan',
      salesRelatesTo: 'home-loan-application-online',
      shop: 'car-shop',
      channel: 'vx-internal',
    };
    this.a = JSON.stringify(this.submissionService.parse(testPacket1, defaults), null, 2);
  }

}
